/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TimeUseStandard } from './timeUseStandard';


export interface StatusCodeValueTimeUseStandard { 
    value?: TimeUseStandard;
    status_code?: number;
}

